import { render } from "./vechicleDetailsModal.vue?vue&type=template&id=03d90b94&scoped=true"
import script from "./vechicleDetailsModal.vue?vue&type=script&lang=js"
export * from "./vechicleDetailsModal.vue?vue&type=script&lang=js"

import "./vechicleDetailsModal.vue?vue&type=style&index=0&id=03d90b94&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d90b94"]])

export default __exports__